import React from 'react'
import { Box, Paper, Stack, Typography } from '@mui/material'

// White card with a titled header row. `action` renders on the right of the
// header (e.g. an Edit button); `dense` trims the padding for lists.
const SectionCard = ({
  title,
  subtitle,
  icon,
  action,
  dense = false,
  children,
  sx,
  contentSx,
}) => (
  <Paper
    elevation={0}
    sx={{
      border: '1px solid #E2E8F0',
      borderRadius: 3,
      bgcolor: '#FFFFFF',
      overflow: 'hidden',
      display: 'flex',
      flexDirection: 'column',
      ...sx,
    }}
  >
    {(title || action) && (
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        gap={1}
        sx={{
          px: 2,
          py: 1.25,
          borderBottom: '1px solid #EEF2F7',
        }}
      >
        <Stack direction="row" alignItems="center" gap={1} minWidth={0}>
          {icon && (
            <Box color="text.secondary" display="flex" sx={{ '& svg': { fontSize: 18 } }}>
              {icon}
            </Box>
          )}
          <Box minWidth={0}>
            <Typography fontWeight={700} noWrap>
              {title}
            </Typography>
            {subtitle && (
              <Typography variant="caption" color="text.secondary" display="block">
                {subtitle}
              </Typography>
            )}
          </Box>
        </Stack>
        {action && (
          <Stack direction="row" gap={0.5} alignItems="center" flexShrink={0}>
            {action}
          </Stack>
        )}
      </Stack>
    )}
    <Box sx={{ p: dense ? 0 : 2, flex: 1, ...contentSx }}>{children}</Box>
  </Paper>
)

export default SectionCard
